import { registerModuleDataProvider } from '../../providers/CustomDataProvider';
import { dataProvider } from './dataProvider';

// 注册 activity/tasks 模块的数据提供者
export function initActivityTasksDataProvider() {
  registerModuleDataProvider('invite-codes', dataProvider);
}

// 自动初始化
initActivityTasksDataProvider();
